import React from "react";
import { ReactFlowStateContext } from "../ReactFlowStateContext";

export function useReactFlowState() {
  return React.useContext(ReactFlowStateContext);
}
